<template>
  <div>
    <h3 class="txt-center mb-2" :class="$store.getters['isMobile'] ? 'txt-title-small' : $store.getters['isLaptop'] ? 'txt-title' : 'txt-title-large'"><b>Forgot your password?</b></h3>
    <p v-if="!prefilled" class="txt-center mb-1 txt-muted pb-4 mb-4 mx-auto txt-wrap-pretty" style="max-width: 450px;" :class="$store.getters['isMobile'] ? 'txt-body' : 'txt-heading-small'">Enter the email address you used when you signed up and we’ll send you instructions to reset your password.</p>

    <b-form @submit.prevent.stop="onSubmit" class="inner-form pt-4">
      <form-control-text
        :state="$v.form.email.$error ? false : null"
        @change="$v.form.email.$touch()"
        id="loginEmail"
        label="Email"
        placeholder="Enter email address..."
        required
        type="email"
        v-model="form.email" />
      <b-btn :disabled="$v.$invalid || loading" block type="submit" variant="primary" :class="$store.getters['isTablet'] ? 'my-3' : 'my-4'">
        Send Reset Instructions
        <svg viewBox="0 0 24 24" class="btn-right icon-regular"><use xlink:href="#icon-send"></use></svg> 
      </b-btn>
      <b-alert :show="!!error" fade variant="error" :class="$store.getters['isTablet'] ? 'mb-3' : 'mb-4'">
        <svg class="alert-icon icon-sm" width="24" viewBox="0 0 24 24"><use xlink:href="#icon-status-error-color"></use></svg>
        <div class="alert-content">
          <span class="txt-body">{{ error }} <a @click.prevent="onReset()" class="alert-link">Try again?</a></span>
        </div>
      </b-alert>
      <b-alert class="mb-0" variant="error" :show="!!error && showError">
        <svg class="alert-icon icon-sm" width="24" viewBox="0 0 24 24"><use xlink:href="#icon-status-error-color"></use></svg>
        <div class="alert-content">
          <span class="txt-body">{{ error }}</span>
        </div>
      </b-alert>

      <b-btn @click="$router.push({name: 'login'})" :disabled="loading" block variant="secondary mt-0" :class="$store.getters['isTablet'] ? 'mb-3' : 'mb-4'">
        <svg viewBox="0 0 24 24" class="btn-left"><use xlink:href="#icon-arrow-left"></use></svg>
        Back to Login
      </b-btn>
      <p class="txt-body txt-center auth-page-cta with-arrow-bottom">
        <span class="txt-muted">Don’t have an account?</span>
        <b-btn variant="link-text ml-1" :to="{name: 'Register'}"><b class="txt-primary">Sign Up for free!</b></b-btn>
      </p>
    </b-form>
  </div>
</template>

<script>
import { email, required } from 'vuelidate/lib/validators';
import { createNamespacedHelpers } from 'vuex';
import get from 'lodash/get';
import { emailFormatter } from '@app2/utils/helpers';
import FormControlText from "@app2/core/Components/Common/Forms/Text";

const { mapActions: mapAuthActions } = createNamespacedHelpers('auth');
export default {
  name: 'ForgotPassword',
  components: {FormControlText },
  data: () => ({
    form: {
      email: '',
    },
    token: null,
    error: null,
    loading: null,
    prefilled: false,
  }),
  validations: {
    form: {
      email: {
        required,
        email: (val) => email(emailFormatter(val)),
      },
    },
  },
  created() {
    if (this.$route.query.email) {
      this.form.email = this.$route.query.email
      this.prefilled = true;
    }
  },
  metaInfo() {
    return {
      title: 'Forgot Password',
    }
  },
  methods: {
    ...mapAuthActions(['forgotPassword']),
    async onSubmit() {
      this.error = null;
      this.loading = true;
      try {
        await this.forgotPassword(this.form.email);
        this.$toasted.show(`An email has been sent to ${this.form.email}`, { type: 'success', position: 'bottom-right' });
        this.$router.push({ name: 'login' });
      } catch ({ data }) {
        this.error = get(data, 'errors.email.0', data.message);
      } finally {
        this.loading = null;
      }
    },
    onReset() {
      this.error = null;
      this.form.email = null;
      this.form.password = null;
      this.prefilled = false;
      this.$v.$reset();
    }
  },
};
</script>
